<template lang="html">
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
    <div class="margintop-32" />
    <tl-header type="h1">
      <div class="main-header">Add Leave Inputs</div>
    </tl-header>
    <div class="essStatus">
        <div class="flex-box">
          <tl-radio name="Variable" id="manual1" :value="true" v-on:change="manualEntry" v-model="formData.manual" label="Manual"/>
          <tl-radio name="Variable" id="bulk" :value="false" v-on:change="bulkUpload" v-model="formData.manual" label="Bulk Upload"/>
        </div>
    </div>
    <div class="margintop-30">
      <div v-if="manual">
        <!-- <div class="label-text">Select Employee</div> -->
        <div class="row">
          <search-dropdown class="col-3"
            placeholder="Search Emplyee name/code"
            label="Select Employee"
           :employeeData="customEmpList"
           @getList="searchDataList($event)"
           @empselected="(emp)=>selectedEmp(emp)"/>
          <tl-select class="col-2"
            labelText="leaveType"
            label="Select Entity"
            :options="leavesTypes"
            v-model='formData.leavetype'
            @change="(val)=>formData.leavetype = val"/>
          <tl-select class="col-2"
            label="Select Month"
            :options="monthList"
            v-model='formData.month'
            @change="(val)=>formData.month = val"/>
        </div>
        <div class="filters margin-t-m">
          <txt
            label='Opening Balance'
            type="number"
            v-model='formData.openBal'
            placeholder=""
            name="openBal"
            @onValueChange="save"/>
           <txt
            label='Credit for the month'
            type="number"
            v-model='formData.creditmonth'
            placeholder=""
            name="creditmonth"
            @onValueChange="save"/>
           <txt
            label='Availed for the month'
            type="number"
            v-model='formData.availedleaves'
            placeholder=""
            name="availedleaves"
            @onValueChange="save"/>
          </div>
          <div class="filters margin-t-m">
           <txt
            label='Lapsed leaves'
            type="number"
            v-model='formData.lapsedLeave'
            placeholder=""
            name="lapsedLeave"
            @onValueChange="save"/>
          </div>
          <p class="gray-text margin-t-s" v-if="formData.closingBal"><b>Closing Balance:</b>  {{formData.closingBal}}</p>
      </div>
      <div v-else>
          <div class="download-btn">
              <download-button></download-button>
          </div>
          <upload/>
      </div>
      <pop-up-message v-if="showSuccessMsg"
        :message="`Leave inputs added!.`"
        btnText="Back to Add Leave Inputs"
        @back="backfrompopup()"/>
    </div>
    <footer>
      <bottom-action-container class="position-fixed">
        <btn-grp slot="end">
          <btn text="cancel" type="secondary" ></btn>
          <btn text="Submit" type="primary" @click="save"></btn>
        </btn-grp>
       </bottom-action-container>
    </footer>
 </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Add Leave Inputs",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/addLeaveInputs`
              }
        ],
      manual: true,
      auto_suggestions: false,
      showSuccessMsg: false,
      empcode: "",
      closingBalance:"",
      formData: {
        bulkUpload: false,
        manual: true,
        leavetype: "",
        month:"",
        openBal: "",
        closingBal: "",
        creditmonth: "",
        lapsedLeave: "",
        availedleaves: ""
      },
      leavesTypes: ["Paid Leave", "Casual Leave", "Sick Leave"],
      monthList: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      employeeData: [],
      customEmpList: []
    };
  },
  methods: {
    ...mapActions({
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      fetchEmployees: "globalapi/globalemployees/fetchAll",
      fetch_leaves_data: "dashboard/organisation/utilities/empleavesdata/fetchAll",
      act_create: "dashboard/organisation/utilities/empleavesdata/create"
      // act_download:"dashboard/organisation/utilities/crudit/downloadC"
    }),
    routeToMainStep(main_step_name) {
      this.$router.push({
        path: `/dashboard/${main_step_name}`
      });
    },
    routeToSubStep(sub_step_name) {
      this.$router.push({
        path: `/dashboard/organisation/${sub_step_name}`
      });
    },
    manualEntry() {
      //console.log("manual", this.formData.manual);
      this.manual = true;
    },
    bulkUpload() {
      this.manual = false;
    },
    async performAction() {
      let reqObj = {
        employeeId: this.empcode,
        month:this.formData.month,
        leave_data: {
          type: this.formData.leavetype,
          openingBalance: this.formData.openBal,
          credit: this.formData.creditmonth,
          availed: this.formData.availedleaves,
          lapsed: this.formData.lapsedLeave,
        }
      };
      try {
        this.$root._data.isSaving = true;
        let res = await this.act_create({
          data: {
            ...reqObj,
          }
        });
        setTimeout(() => {
          if (res.data.status) {
            // debugger;
            this.toast = false;
            this.showSuccessMsg = true;
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          //console.log("perform signup", result);
          this.performAction();
        }
      });
    },
    backfrompopup() {
      this.showSuccessMsg = false;
      this.formData = {
        bulkUpload: false,
        manual: true,
        leavetype: "",
        openBal: "",
        creditmonth: "",
        lapsedLeave: "",
        availedleaves: "",
        month:""
      }
    },
    searchDataList(val) {
      this.getEmployeesByName(val);
    },

    async getEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByName(val);
        if (res.data.payload.data) {
          this.customEmpList = res.data.payload.data;
        }
      } catch (error) {
        //console.log("error:", error);
        this.toast = true;
        this.errmsg = error;
      }
    },
    async selectedEmp(emp) {
      //console.log("emp sleected data", emp);
      this.empcode = emp.id;
      let res = await this.fetch_leaves_data(emp.id);
      if (res.data.status) {
        this.formData["openBal"] = res.data.payload.leave_data.openingBalance,
          this.formData["creditmonth"] = res.data.payload.leave_data.credit,
          this.formData["lapsedLeave"] = res.data.payload.leave_data.lapsed,
          this.formData["leavetype"] = res.data.payload.leave_data.type;
          this.formData['month'] = res.data.payload.leave_data.type;
          this.formData["availedleaves"] = res.data.payload.leave_data.availed;
          this.formData["closingBal"] = res.data.payload.leave_data.closingBalance;

      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins
bottom-action-container.position-fixed {
  position: fixed;
}
.download-btn {
  margin-bottom: 1.6%;
}
.flex-box {
  display: flex;
}
.upload {
  grid-row: span 2;
  width: 300px;
  line-height: 7px;
}
</style>
